import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { supabase } from './lib/supabase'
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Dashboard from './pages/Dashboard'
import SavedSearches from './pages/SavedSearches'
import Agencies from './pages/Agencies'
import Admin from './pages/Admin'
import RecentSearches from './pages/RecentSearches'
import History from './pages/History'
import Upgrade from './pages/Upgrade'
import ThankYou from './pages/ThankYou'
import './App.css'

function AuthHandler() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('[APP] Auth state changed:', event, { hasSession: !!session })

      if (event === 'SIGNED_IN' && session) {
        if (location.pathname === '/login' || location.pathname === '/signup') {
          console.log('[APP] User signed in, redirecting to dashboard')
          navigate('/dashboard', { replace: true })
        }
      } else if (event === 'SIGNED_OUT') {
        console.log('[APP] User signed out')
        if (location.pathname === '/dashboard') {
          navigate('/', { replace: true })
        }
      } else if (event === 'TOKEN_REFRESHED') {
        console.log('[APP] Token refreshed successfully')
      }
    })

    return () => {
      authListener?.subscription?.unsubscribe()
    }
  }, [navigate, location])

  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthHandler />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/auth/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/saved" element={<SavedSearches />} />
        <Route path="/agencies" element={<Agencies />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/recent-searches" element={<RecentSearches />} />
        <Route path="/history" element={<History />} />
        <Route path="/upgrade" element={<Upgrade />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  )
}
